import { render } from "./Col9.vue?vue&type=template&id=0da595ac"
import script from "./Col9.vue?vue&type=script&lang=js"
export * from "./Col9.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__